import axios from "axios"

/**
 * Image sizes available
 */
export enum ImageSize {
  thumbnail= 'thumbnail',
  medium = 'medium',
  large = 'large',
  original = 'original',
}

export function fileUrl(id: number, size: ImageSize = ImageSize.original): string {
  return `${import.meta.env.VITE_API_BASE_URL}/files/${id}/${size}`
}

export function downloadFile(id: number, size: ImageSize = ImageSize.original): Promise<any> {
  return axios.download(fileUrl(id, size))
}
